export default __webpack_public_path__ + "static/media/2079_01B.63e076c3.jpg";